import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@predoc/cow';
import { FileText, MoreVertical, UserRound } from 'lucide-react';
import { isEfaxProcessingOrCompleted, type EfaxQueueItem } from '../../types';

interface EfaxActionDropdownProps {
  item: EfaxQueueItem;
  onOpenDocuments: (item: EfaxQueueItem, documentId?: string) => void;
  onViewPatient: (item: EfaxQueueItem) => void;
}

export const EfaxActionDropdown = ({
  item,
  onOpenDocuments,
  onViewPatient,
}: EfaxActionDropdownProps) => {
  const canViewPatient =
    isEfaxProcessingOrCompleted(item.status) && !!item.patient?.referenceId;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="eFax actions">
          <MoreVertical className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="bottom" align="end">
        <DropdownMenuItem
          className="cursor-pointer"
          onClick={() => onOpenDocuments(item, item.recordUploadId)}
        >
          <FileText className="size-4" />
          View Document
        </DropdownMenuItem>
        <DropdownMenuItem
          className={canViewPatient ? 'cursor-pointer' : undefined}
          disabled={!canViewPatient}
          onClick={() => onViewPatient(item)}
        >
          <UserRound className="size-4" />
          View Patient
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
